import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'loan';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    loanDetails: '',
    loanId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    billCode: ''
}
export const mutations = {
    setLoanDetails(state, data) {
        state.loanDetails = data
    },
    setIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setLoanId(state, data) {
        state.loanId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setRouterUrl(state, url) {
        state.routerUrl = url
    },
    setIsView(state, flag) {
        state.isView = flag
    },
    setDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/loan/index.js